//在src/icons/index.js中使用webpack的require.context自动引入src/icons下面所有的图标
// const req = require.context("./svg", false, /\.svg$/);-- 
// const requireAll = requireContext => requireContext.keys().map(requireContext);
// requireAll(req);

import Vue from 'vue';
// 引入svg图标组件
import SvgIcon from '@/components/SvgIcon.vue';
// 注册全局svg组件
Vue.component('svg-icon', SvgIcon);

const req = require.context('./svg', false, /\.svg$/);
// ['qq.svg','wx.svg']
req.keys().map(req);

// <!-- svg图标组件引用方式 -->
// icon-class：图标文件名称
// <!-- <svg-icon icon-class="qq"/> -->